var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Property, Complex, ChildProperty, Collection } from '@syncfusion/ej2-base';
/**
 * Defines the combination of keys and modifier keys
 */
export class KeyGesture extends ChildProperty {
}
__decorate([
    Property()
], KeyGesture.prototype, "key", void 0);
__decorate([
    Property()
], KeyGesture.prototype, "keyModifiers", void 0);
/**
 * Defines a command and a key gesture to define when the command should be executed
 */
export class Command extends ChildProperty {
    /**
     *
     * Returns the name of class Command
     *
     * @returns {string}  Returns the name of class Command
     * @private
     */
    getClassName() {
        return 'Command';
    }
}
__decorate([
    Property('')
], Command.prototype, "name", void 0);
__decorate([
    Property()
], Command.prototype, "canExecute", void 0);
__decorate([
    Property()
], Command.prototype, "execute", void 0);
__decorate([
    Complex({}, KeyGesture)
], Command.prototype, "gesture", void 0);
__decorate([
    Property('')
], Command.prototype, "parameter", void 0);
/**
 * Defines the collection of commands and the corresponding key gestures
 *
 */
export class CommandManager extends ChildProperty {
}
__decorate([
    Collection([], Command)
], CommandManager.prototype, "commands", void 0);
/**
 * Defines the behavior of the context menu items
 */
export class ContextMenuSettings extends ChildProperty {
}
__decorate([
    Property()
], ContextMenuSettings.prototype, "show", void 0);
__decorate([
    Property()
], ContextMenuSettings.prototype, "showCustomMenuOnly", void 0);
__decorate([
    Property()
], ContextMenuSettings.prototype, "items", void 0);
